// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R

import { useTranslation } from 'react-i18next';
import RouteList from 'components/organisms/RouteList';
import CollectRouteTemplate from 'components/templates/CollectRouteTemplate';

const CollectRoutes = () => {
  const { t } = useTranslation();

  return (
    <CollectRouteTemplate h1={t('collects.title')}>
      <RouteList />
    </CollectRouteTemplate>
  );
};

export default CollectRoutes;
